<div class="mx-0 player">
  <div class="player__image-rounded" [ngStyle]="{'background-image': 'url(\'' + logoUrl + '\')'}"></div>
  <div class="player__info">
    <div class="player__info-left" *ngIf="isTrainer">
      <h4 class="player__number" *ngIf="number">{{ number }}</h4>
      <div class="player__names">
        <h4 *ngIf="firstname">{{ firstname }} {{ lastname }}</h4>
        <h4 *ngIf="!firstname">{{ trainername }}</h4>
        <h4 class="player__condition">{{ position }}</h4>
      </div>
    </div>
    <div class="player__info-left" *ngIf="!isTrainer">
      <h4 class="player__number mb-0">{{ number }}</h4>
      <div class="player__names">
        <h4><span>{{ firstname }}</span> {{ lastname }}</h4>
        <h4 *ngIf="status" class="player__condition">{{ status }}</h4>
      </div>
    </div>
  </div>
  <div *ngIf="skillsLabScore" class="player__skills-lab-score">
      <a [href]="skillsLabLink" target="_blank"><img alt="skills.lab" [src]="skillsLabLogo"></a>
      <a [href]="skillsLabLink" target="_blank"><span>{{ skillsLabScore }}</span></a>
  </div>
</div>
